/*
 * Public API Surface of error-page
 */

export * from './lib/error-page';
export * from './lib/page-401/page-401.component';
export * from './lib/page-500/page-500.component';
export * from './lib/exception-manager';
